import { Container } from '@resolute/ui';
import { ShieldCheck } from 'lucide-react';

import { HeroSearch } from '../hero-search/hero-search';

import { Reveal } from '@/components/motion/reveal';
import { buildSrcSet, imageUrl } from '@/lib/image';

const HERO_IMAGE = '/hero-background.webp';

export function Hero() {
  return (
    <section className="relative isolate flex min-h-[calc(100svh_-_3.5rem)] items-center overflow-hidden bg-[hsl(var(--primary))] lg:min-h-[calc(100svh_-_4rem)]">
      {/* Premium full-bleed background image. LCP-safe: fetched with high priority. */}
      <img
        src={imageUrl(HERO_IMAGE, 1600)}
        srcSet={buildSrcSet(HERO_IMAGE, [828, 1200, 1600, 2000])}
        sizes="100vw"
        alt=""
        decoding="async"
        fetchPriority="high"
        aria-hidden="true"
        className="absolute inset-0 -z-20 size-full object-cover"
      />
      {/* Soft gradient overlay keeps the copy legible while preserving image brightness. */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-b from-black/30 via-black/10 to-black/30"
      />
      <Container className="flex w-full flex-col items-center py-14 text-center">
        <Reveal y={16} className="max-w-4xl">
          <h1 className="text-balance font-display text-display-md font-semibold tracking-tight text-white [text-shadow:0_2px_24px_rgba(0,0,0,0.35)]">
            Find a home worth <span className="text-secondary">coming back to.</span>
          </h1>
        </Reveal>

        <Reveal y={20} delay={0.12} className="mt-24 w-full max-w-6xl">
          <HeroSearch />
        </Reveal>

        {/* Light supporting line — a fixed, modest distance below the search
            widget (not pinned to the section's bottom edge, which on a tall
            viewport left a large, viewport-dependent gap here). States what
            we do, deliberately without a listing/transaction count — no
            figure here is verifiable from the live inventory. */}
        <Reveal y={12} delay={0.22}>
          <p className="mt-8 flex items-center gap-2 text-sm text-white/80">
            <ShieldCheck className="size-4 shrink-0 text-secondary" aria-hidden="true" />
            RERA-verified properties across Ahmedabad, Gandhinagar &amp; GIFT City
          </p>
        </Reveal>
      </Container>
    </section>
  );
}
